import { createAction } from "@reduxjs/toolkit"

export const raffleTicketAction = createAction("raffleTicketAction")
export const WineMonthVideoThumbnailAction = createAction("WineMonthVideoThumbnailAction")
export const uploadWineOfTheMonthAction = createAction("uploadWineOfTheMonthAction")
export const getWineMonthAction = createAction("getWineMonthAction")
export const deleteWineMonthAction = createAction("deleteWineMonthAction")
export const getSingleWineMonthDataAction = createAction("getSingleWineMonthDataAction")
export const editWineOfTheMonthItemAction = createAction("editWineOfTheMonthItemAction")

export const editRaffleContestAction = createAction("editRaffleContestAction")

export const getRaffleListDataAction = createAction("getRaffleListDataAction")

export const deleteRaffleContestAction = createAction("deleteRaffleContestAction")
export const getRaffleSingleDataAction = createAction("getRaffleSingleDataAction")

export const uploadPDFThumbnailAction = createAction("uploadPDFThumbnailAction")

export const getMenuPeriodAction = createAction("getMenuPeriodAction")

export const addCommentCalenderAction = createAction("addCommentCalenderAction")
export const EditCommentCalenderAction = createAction("EditCommentCalenderAction")
export const EditMenuCategoryAction = createAction("EditMenuCategoryAction")
export const AddMenuCategoryAction = createAction("AddMenuCategoryAction")
export const DeleteMenuCategoryAction = createAction("DeleteMenuCategoryAction")
export const uploadMenuItemAction = createAction("uploadMenuItemAction")
export const addMenuItemsActions = createAction("addMenuItemsActions")
export const deleteMenuItemAction = createAction("deleteMenuItemAction")
export const getFoodItemsAction = createAction("getFoodItemsAction")
export const updateFoodItemsAction = createAction("updateFoodItemsAction")
export const moveFoodItemCategoryAction = createAction("moveFoodItemCategoryAction")
export const reorderMenuItemsAction = createAction("reorderMenuItemsAction")
export const reorderMenuCategoriesAction = createAction("reorderMenuCategoriesAction")
export const uploadTastingNotesImagesAction = createAction("uploadTastingNotesImagesAction")
export const getLeaderboardDataAction = createAction("getLeaderboardDataAction")
export const getNewLeaderboardDataAction = createAction("getNewLeaderboardDataAction")
export const getSingleUserDataGraphAction = createAction("getSingleUserDataGraphAction")
export const revertAllMarketing = createAction("revertAllMarketing")
export const getBarMenuPeriodAction = createAction("getBarMenuPeriodAction")
export const getWineMenuPeriodAction = createAction("getWineMenuPeriodAction")
export const addWineMenuItemsAction = createAction("addWineMenuItemsAction")
export const getWineItemsAction = createAction("getWineItemsAction")
export const updateWineItemsAction = createAction("updateWineItemsAction")
export const deleteWineItemAction = createAction("deleteWineItemAction")
export const addBarMenuItemsAction = createAction("addBarMenuItemsAction")
export const getBarItemsAction = createAction("getBarItemsAction")
export const updateBarItemsAction = createAction("updateBarItemsAction")
export const deleteBarItemAction = createAction("deleteBarItemAction")
export const AddBarMenuCategoryAction = createAction("AddBarMenuCategoryAction")
export const EditBarMenuCategoryAction = createAction("EditBarMenuCategoryAction")
export const DeleteBarMenuCategoryAction = createAction("DeleteBarMenuCategoryAction")
export const unArchiveItemsAction = createAction("unArchiveItemsAction")
export const unArchiveBarItemsAction = createAction("unArchiveBarItemsAction")
export const importSpiritItemAction = createAction("importSpiritItemAction")
export const getSpiritCMSAction = createAction("getSpiritCMSAction")
export const getArchivedSpiritCMSAction = createAction("getArchivedSpiritCMSAction")
export const unArchiveSpiritsItemsAction = createAction("unArchiveSpiritsItemsAction")
export const archiveSpiritItemsAction = createAction("archiveSpiritItemsAction")
export const unarchiveWineItemsAction = createAction("unarchiveWineItemsAction")
export const addarchiveSpiritItemsAction = createAction("addarchiveSpiritItemsAction")
export const deleteSpiritMenuItemAction = createAction("deleteSpiritMenuItemAction")
export const getSpiritItemsAction = createAction("getSpiritItemsAction")
export const updateSpiritItemsAction = createAction("updateSpiritItemsAction")
export const getNewSpiritCountAction = createAction("getNewSpiritCountAction")
export const getGamificationLeaderboardDataAction = createAction(
  "getGamificationLeaderboardDataAction"
)
export const getNewGamificationLeaderboardDataAction = createAction(
  "getNewGamificationLeaderboardDataAction"
)
export const getQuizLeaderBoardDataAction = createAction("getQuizLeaderBoardDataAction")
export const getMenuSubCategoryAction = createAction("getMenuSubCategoryAction")
export const uploadMenuBulkAction = createAction("uploadMenuBulkAction")
export const AddWineMenuCategoryAction = createAction("AddWineMenuCategoryAction")
export const editWineMenuCategoryAction = createAction("editWineMenuCategoryAction")
export const deleteWineMenuCategoryAction = createAction("deleteWineMenuCategoryAction")
export const unArchiveWineItemsAction = createAction("unArchiveWineItems")
export const uploadDidYouKnowImageAction = createAction("uploadDidYouKnowImageAction")
export const uploadHistoryMediaAction = createAction("uploadHistoryMediaAction")
export const searchDidYouKnowImagesAction = createAction("searchDidYouKnowImagesAction")
export const confirmDidYouKnowImageAction = createAction("confirmDidYouKnowImageAction")
export const getWeeklyChallengeAction = createAction("getWeeklyChallengeAction")
export const getNextWeeklyChallengeAction = createAction("getNextWeeklyChallengeAction")
export const getLastWeeklyChallengeAction = createAction("getLastWeeklyChallengeAction")
export const getPreviousToLastWeeklyChallengeAction = createAction(
  "getPreviousToLastWeeklyChallengeAction"
)
export const editWeeklyChallengeAction = createAction("editWeeklyChallengeAction")
export const getWeeklyQuizAction = createAction("getWeeklyQuizAction")
export const getNextWeeklyQuizAction = createAction("getNextWeeklyQuizAction")
export const getLastWeeklyQuizAction = createAction("getLastWeeklyQuizAction")
export const getPreviousToLastWeeklyQuizAction = createAction("getPreviousToLastWeeklyQuizAction")
export const editWeeklyQuizAction = createAction("editWeeklyQuizAction")
export const viewWeeklyChallengeAction = createAction("viewWeeklyChallengeAction")
export const viewWeeklyQuizAction = createAction("viewWeeklyQuizAction")
export const getViewChallengeQuestionsAction = createAction("getViewChallengeQuestionsAction")
export const getViewQuizQuestionsAction = createAction("getViewQuizQuestionsAction")
export const deleteChallengeQuestionAction = createAction("deleteChallengeQuestionAction")
export const editChallengeQuestionAction = createAction("editChallengeQuestionAction")
export const weeklyCategoryAction = createAction("weeklyCategoryAction")
export const getWeeklyQuestionsBankAction = createAction("getWeeklyQuestionsBankAction")
export const ReplaceChallengeMenuItemAction = createAction("ReplaceChallengeMenuItemAction")
export const addWeeklyManualQuestionToBankAction = createAction(
  "addWeeklyManualQuestionToBankAction"
)
export const getWeeklyCategoryMenuItemAction = createAction("getWeeklyCategoryMenuItemAction")
export const generateWeeklyQuestionAction = createAction("generateWeeklyQuestionAction")
export const addQuestionToChallengeAction = createAction("addQuestionToChallengeAction")
export const addToWeeklyQuestionBankAction = createAction("addToWeeklyQuestionBankAction")
export const deleteWeeklyQuestionFromBankAction = createAction("deleteWeeklyQuestionFromBankAction")
export const generateSoundbitesAction = createAction("generateSoundbitesAction")
export const updateQuizQuestionsAction = createAction("updateQuizQuestionsAction")
export const addWeeklyManualQuestionV2ToBankAction = createAction(
  "addWeeklyManualQuestionV2ToBankAction"
)
export const uploadBulkQuestionAction = createAction("uploadBulkQuestionAction")
export const bulkDeleteQuestionsAction = createAction("bulkDeleteQuestionsAction")
export const getCommentsAction = createAction("getCommentsAction")
export const updateCommentStatusAction = createAction("updateCommentStatusAction")
export const generateHistoryAction = createAction("generateHistoryAction")
export const generateDidYouKnowAction = createAction("generateDidYouKnowAction")
export const setupWeeklyQuizzesAction = createAction("setupWeeklyQuizzesAction")
export const setupWeeklyChallengesAction = createAction("setupWeeklyChallengesAction")
export const swapWeeklyChallengesAction = createAction("swapWeeklyChallengesAction")
export const generateSoundbiteTextAction = createAction("generateSoundbiteTextAction")
export const getSoundbiteVoiceIdsAction = createAction("getSoundbiteVoiceIdsAction")
export const aiEnhanceFieldAction = createAction("aiEnhanceFieldAction")
export const enhanceDidYouKnowFieldAction = createAction("enhanceDidYouKnowFieldAction")
export const removeImageBackgroundAction = createAction("removeImageBackgroundAction")
export const uploadMenuForReviewAction = createAction("uploadMenuForReviewAction")
export const getReviewMenuCategoriesAction = createAction("getReviewMenuCategoriesAction")
export const getReviewMenuPeriodAction = createAction("getReviewMenuPeriodAction")
export const getReviewBarMenuPeriodAction = createAction("getReviewBarMenuPeriodAction")
export const getReviewWineMenuPeriodAction = createAction("getReviewWineMenuPeriodAction")
export const getReviewSpiritCMSAction = createAction("getReviewSpiritCMSAction")
export const getReviewMenuSubCategoryAction = createAction("getReviewMenuSubCategoryAction")
export const publishReviewMenuAction = createAction("publishReviewMenuAction")
export const getUploadStatusAction = createAction("getUploadStatusAction")
export const exportMenuListAction = createAction("exportMenuListAction")
